import { getAmino } from "./config/amino"
import { getInterra } from "./config/interra"
import { getOmnia } from "./config/omnia"
import { OmniaConfig } from "./shared/config"

export function getAppConfig(): OmniaConfig {
    const production = checkProductionHost(location.host)

    const baseUrl = [location.protocol, "//", location.host, location.pathname].join("").replace(/\/$/, "")

    const apiUrl = API_BASE_URL || baseUrl + "/api"

    const features = /amino/i.test(location.host)
        ? getAmino(production)
        : /interra/i.test(location.host)
        ? getInterra(production)
        : getOmnia(production)

    return {
        production,
        baseUrl,
        apiUrl,
        ...features,
    }
}

function checkProductionHost(host: string) {
    switch (host) {
        case "production-omniahub.azurewebsites.net":
        case "production-interrascan.azurewebsites.net":
        case "omniahub.co.uk":
        case "www.omniahub.co.uk":
        case "interrascan.com":
        case "www.interrascan.com":
            return true

        default: {
            const re = new RegExp("^production-(omniahub|interrascan)-\\w+\\.azurewebsites\\.net$")
            const testingHostRegex = new RegExp("^(production|preprod)[\\w\\-]+\\.testing-omniahub\\.co\\.uk$")
            return re.test(host) || testingHostRegex.test(host)
        }
    }
}
